import { alpha } from "@mui/material/styles";
import { chipSemantico } from "../../../utils/centralDeAlertas/cores";

// Estilos da TabelaIncidentes (Central de Alertas): tabela ordenável com
// linhas expansíveis, destaque de foco vindo da TimelineGlobal e chips
// semânticos sempre derivados da paleta do tenant (nunca hex fixo).
const styles = (theme) => {
	return {
		// Linha do cabeçalho: título/legenda à esquerda, botão ⓘ à direita.
		linhaCabecalho: {
			display: "flex",
			alignItems: "flex-start",
			justifyContent: "space-between",
			gap: 1,
		},
		container: {
			width: "100%",
			height: "100%",
			borderRadius: "10px",
			p: "16px",
			display: "flex",
			flexDirection: "column",
			gap: 1.5,
		},
		cabecalho: {
			display: "flex",
			flexDirection: "column",
			gap: "2px",
		},
		legenda: {
			color: theme.palette.text.secondary,
		},
		barraAcoes: {
			display: "flex",
			flexDirection: "row",
			alignItems: "center",
			justifyContent: "space-between",
			gap: 1,
			flexWrap: "wrap",
		},
		campoBusca: {
			width: "100%",
			maxWidth: "360px",
			"& .MuiInputBase-input": {
				fontSize: "0.875rem",
			},
		},
		iconeBusca: {
			color: theme.palette.text.secondary,
		},
		botaoExportar: {
			textTransform: "none",
			whiteSpace: "nowrap",
		},
		containerTabela: {
			width: "100%",
			overflowX: "auto",
		},
		tabela: {
			minWidth: "960px",
		},
		celulaCabecalho: {
			whiteSpace: "nowrap",
			fontWeight: 600,
			color: theme.palette.text.secondary,
		},
		// Linha principal: as bordas ficam por conta da célula de expansão
		// logo abaixo, evitando divisor duplo quando a linha está recolhida.
		linha: (destacada) => ({
			cursor: "pointer",
			transition: "background-color 0.4s ease",
			backgroundColor: destacada
				? alpha(theme.palette.primary.main, 0.14)
				: "transparent",
			"& > .MuiTableCell-root": {
				borderBottom: "none",
			},
		}),
		celulaNowrap: {
			whiteSpace: "nowrap",
		},
		// Título do alerta pode ser longo: corta com reticências e o texto
		// completo fica no Tooltip.
		celulaAlerta: {
			maxWidth: "280px",
		},
		// Ícone do tipo + título na mesma linha; minWidth 0 para o ellipsis do
		// texto continuar funcionando dentro do flex.
		linhaTituloAlerta: {
			display: "flex",
			alignItems: "center",
			gap: "6px",
			minWidth: 0,
		},
		textoAlerta: {
			overflow: "hidden",
			textOverflow: "ellipsis",
			whiteSpace: "nowrap",
		},
		// Coluna "Linha do tempo": mesma régua de marcos da Análise de padrão.
		linhaDoTempoTabela: {
			display: "flex",
			flexDirection: "row",
			alignItems: "center",
			gap: "6px",
		},
		// Ícone de marco: cor semântica do marco quando o registro existe;
		// esmaecido quando não.
		iconeMarcoTabela: (cor) => ({
			fontSize: "1.05rem",
			...(cor
				? { color: cor }
				: { color: theme.palette.text.secondary, opacity: 0.5 }),
		}),
		celulaAcoes: {
			whiteSpace: "nowrap",
			width: "56px",
		},
		chipTabela: (cor) => ({
			...chipSemantico(theme, cor),
			border: "1px solid",
			fontWeight: 500,
			"& .MuiChip-icon": {
				color: "inherit",
				fontSize: "1rem",
			},
		}),
		iconeExpandir: (expandido) => ({
			transition: "transform 0.2s ease",
			transform: expandido ? "rotate(180deg)" : "rotate(0deg)",
		}),
		celulaExpansao: {
			py: 0,
		},
		boxExpansao: {
			py: 1.5,
		},
		celulaVazia: {
			py: 6,
			borderBottom: "none",
			textAlign: "center",
		},
		paginacao: {
			"& .MuiTablePagination-toolbar": {
				minHeight: "44px",
			},
		},
		skeletonConteudo: {
			display: "flex",
			flexDirection: "column",
			gap: 1,
		},
		skeletonBarra: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between",
			gap: 1,
		},
		skeletonBusca: {
			width: "100%",
			maxWidth: "360px",
			height: "40px",
		},
		skeletonBotao: {
			width: "140px",
			height: "32px",
		},
		skeletonCabecalhoTabela: {
			height: "36px",
		},
		skeletonLinha: {
			height: "44px",
		},
	};
};

export default styles;
